<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep-bot">‘There is a straight line from “You have no right to live among us as Jews” to “You have no right to live among us” to “You have no right to live”.’</p>
<p class="epc">Raul Hilberg</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?761284f2